// product-description-toggle.js

function initProductDescriptionToggle(root = document) {
  const buttons = root.querySelectorAll('[data-description-toggle]');

  if (!buttons.length) return;

  buttons.forEach((button) => {
    // Evitar enganchar el mismo listener varias veces
    if (button.dataset.descriptionToggleInit === 'true') return;
    button.dataset.descriptionToggleInit = 'true';

    button.addEventListener('click', () => {
      const wrapper = button.closest('.product-description-wrapper');
      if (!wrapper) return;

      const more = wrapper.querySelector('[data-description-more]');
      if (!more) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', (!isExpanded).toString());
      more.classList.toggle('hidden', isExpanded);

      // Cambia el texto del botón
      button.textContent = isExpanded ? 'Mostrar más' : 'Mostrar menos';
    });
  });
}

// Cuando se carga la página
document.addEventListener('DOMContentLoaded', () => {
  initProductDescriptionToggle(document);
});

// Cuando Shopify recarga una sección (modo editor, etc.)
document.addEventListener('shopify:section:load', (event) => {
  initProductDescriptionToggle(event.target);
});
